import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger, gsap} from "../LibrariesImport";
import Lenis from 'lenis';

export default class SmoothScroll {
    constructor() {
        const root = document.documentElement;

        if (ScrollTrigger.isTouch === 1) {
            root.classList.add('touchevents');
        } else {
            root.classList.add('no-touchevents');

            const header = document.querySelector('.single-program-subnav');
            const headerHeight = header ? header.offsetHeight + 40 : 40;
            document.documentElement.style.scrollPaddingTop = headerHeight+"px";

            // console.log(headerHeight);

            GlobalVariables.lenis = new Lenis({
                autoRaf: false,
                lerp: 0.1,
                wheelMultiplier: 1,
                anchors: {
                    offset: -headerHeight
                }
            });

            // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
            GlobalVariables.lenis.on('scroll', ScrollTrigger.update);

            // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
            // This ensures Lenis's smooth scroll animation updates on each GSAP tick
            gsap.ticker.add((time) => {
                GlobalVariables.lenis.raf(time * 1000); // Convert time from seconds to milliseconds
            });

            // Disable lag smoothing in GSAP to prevent any delay in scroll animations
            gsap.ticker.lagSmoothing(0);

            // Ensure ScrollTrigger measures correctly when page loads scrolled, bfcache, etc.
            requestAnimationFrame(() => {
                ScrollTrigger.refresh();
            });

            window.addEventListener('load', () => {
                ScrollTrigger.refresh();
            });

            window.addEventListener('pageshow', (e) => {
                if (e.persisted) ScrollTrigger.refresh();
            });
        }
    }
}


